import React from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, MousePointerClick, Filter, Users } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide6UKQualifiedTraffic({
  index
}: SlideProps) {
  const reasons = [{
    icon: Stethoscope,
    title: 'Answers real clinical needs',
    desc: 'Substantive education rather than promotional messaging naturally attracts genuine, practising HCPs.'
  }, {
    icon: MousePointerClick,
    title: 'HCPs self-qualify',
    desc: 'Visitors signal their interest and intent through the topics they choose — before they ever reach product-specific content.'
  }, {
    icon: Filter,
    title: 'Less “scrap” traffic',
    desc: 'Professional, condition-focused content filters out non-HCP visitors, so what reaches Anzupgo is already relevant.'
  }];
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-237">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-238">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-239">
          Traffic Qualification
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.5vw,3rem)] leading-[1.1] max-w-5xl" data-id="element-240">
          Non-branded content sends{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-241">
            more qualified HCPs
          </span>{' '}
          to Anzupgo
        </h2>
      </motion.div>

      {/* Three reasons */}
      <div className="flex-1 grid grid-cols-3 gap-[clamp(1rem,2vw,2rem)] min-h-0" data-id="element-242">
        {reasons.map((r, i) => {
        const Icon = r.icon;
        return <motion.div key={r.title} initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4 + i * 0.15,
          duration: 0.55
        }} className="bg-[var(--surface)] rounded-2xl p-[clamp(1.5rem,2vw,2rem)] border border-black/5 flex flex-col" data-id="element-243">
              <div className="w-12 h-12 rounded-xl bg-[var(--brand-green)] flex items-center justify-center mb-5 flex-shrink-0" data-id="element-244">
                <Icon className="w-6 h-6 text-white" data-id="element-245" />
              </div>
              <h3 className="text-[var(--fg)] font-bold text-[clamp(1.15rem,1.6vw,1.5rem)] leading-tight mb-3" data-id="element-246">
                {r.title}
              </h3>
              <p className="text-[var(--muted)] text-[clamp(0.9rem,1.1vw,1.1rem)] leading-relaxed" data-id="element-247">
                {r.desc}
              </p>
            </motion.div>;
      })}
      </div>

      {/* Payoff strip */}
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="mt-[clamp(1.5rem,2.5vw,2.5rem)] bg-[var(--brand-green)] rounded-2xl p-[clamp(1.5rem,2.5vw,2.5rem)] flex items-center gap-5 flex-shrink-0 shadow-lg" data-id="element-248">
        <div className="w-12 h-12 rounded-xl bg-white/15 flex items-center justify-center flex-shrink-0" data-id="element-249">
          <Users className="w-6 h-6 text-white" data-id="element-250" />
        </div>
        <p className="text-white font-bold text-[clamp(1.1rem,1.8vw,1.6rem)] leading-tight" data-id="element-251">
          Higher-intent traffic reaches Anzupgo — primed by the science, not
          chased by a banner.
        </p>
      </motion.div>
    </div>;
}